import React from 'react';
import { Col, EditableInfoComponent, Row, Typography } from 'components';
import { PaymentsGeneralIcon } from 'components/common/icons';
import { GeneralEditeModal } from 'feature/clientTabs/payments/general/edit';
import { useGeneral } from 'feature/clientTabs/payments/general/useGeneral';
import { useAccessControl } from 'components/common/accessControl/useAccessControl';
import { PERMISSIONS } from 'constants/permissions';

const { Text } = Typography;
export const General = React.memo(() => {
  const { hasAccess } = useAccessControl();
  const { modalState, onModalStateChange, clientDetails } = useGeneral();
  return (
    <>
      <EditableInfoComponent
        title={'General'}
        editable={hasAccess(PERMISSIONS.clients.payment_general.write)}
        icon={<PaymentsGeneralIcon />}
        onEdite={onModalStateChange}
      />
      <Row gutter={[0, 4]}>
        <Col span={24}>
          <Row justify={'space-between'}>
            <Col>
              <Text type={'secondary'}>Legal Name</Text>
            </Col>
            <Col>
              <Text type={'secondary'}>{clientDetails?.legalName || 'Not Set'}</Text>
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Row justify={'space-between'}>
            <Col>
              <Text type={'secondary'}>Formation Type</Text>
            </Col>
            <Col>
              <Text type={'secondary'}>{clientDetails?.formationType || 'Not Set'}</Text>
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Row justify={'space-between'}>
            <Col>
              <Text type={'secondary'}>Tax Number</Text>
            </Col>
            <Col>
              <Text type={'secondary'}>{clientDetails?.taxNumber || 'Not Set'}</Text>
            </Col>
          </Row>
        </Col>
      </Row>
      <GeneralEditeModal modalState={modalState} onModalStateChange={onModalStateChange} dataToEdit={clientDetails} />
    </>
  );
});
